import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { AlertController, ModalController, NavController } from '@ionic/angular';
import { ProducerViewComponent } from 'src/app/components/producer-view/producer-view.component';
import { ProductViewComponent } from 'src/app/components/product-view/product-view.component';
import { MarketModel } from 'src/app/models/market.model';
import { ProductModel } from 'src/app/models/product.model';
import { ProfileModel } from 'src/app/models/profile.model';
import { TourneeModel } from 'src/app/models/tournee.model';
import { DataService } from 'src/app/services/data/data.service';
import { MathService } from 'src/app/services/math/math.service';
import { ProductService } from 'src/app/services/product/product.service';
import { ProductsListRowComponent } from '../products-list-row/products-list-row.component';

@Component({
  selector: 'products-list-organized',
  templateUrl: './products-list-organized.component.html',
  styleUrls: ['./products-list-organized.component.scss'],
})
export class ProductsListOrganizedComponent implements OnInit {

  @Input()
  producers:ProfileModel[];

  @Input()
  title:string;

  @Input()
  mode:string // edit, view, order, catalog, sale, prepare

  @Input()
  loading:boolean = false;


  @Input("itemsOrganized")
  set itemsOrganized(value: any) {
    // console.log('itemsOrganized',value);
    this._itemsOrganized = value;
    this._itemsOrganizedAll = value.all;
    if(value.products){ this.buildFilter(value.products.type)}
  }

  _itemsOrganized:any;
  _itemsOrganizedAll:any[];
  _itemsOrganizedFiltered:any;

  @Input("tournees")
  set tournees (value:TourneeModel[]){
    if(value){
      this._tournees = value;
      this.tourneesFiltered = this.filterProductsAndTournees(value,{});      
    }
  }
  _tournees:TourneeModel[];
  tourneesFiltered:TourneeModel[];

  @Input()
  products:any;

  @Input()
  sortBy:string

  @Input()
  displayFilter:boolean = false;

  @Input()
  viewer:ProfileModel;

  @Output() quantityChanged = new EventEmitter<ProductModel>();
  @Output() editTournee = new EventEmitter<TourneeModel>();
  @Output() scrollTo = new EventEmitter<number>();

  typeFilterArray = [{name:"vegetable-producer", status:false},{name:"fruit-producer",status:false},{name:"butcher",status:false},
                  {name:"poultry",status:false},{name:"fisherman",status:false},{name:"baker",status:false},{name:"miller",status:false},
                  {name:"egger",status:false},{name:"dairy",status:false},{name:"cheese-maker",status:false},{name:"beekeeper",status:false},
                  {name:"wine-maker",status:false},{name:"brewery",status:false},{name:"snack",status:false},{name:"biscuit",status:false},
                  {name:"can",status:false},{name:"ice-cream",status:false},{name:"yogurt",status:false},{name:"condiment",status:false},
                  {name:"jam",status:false},{name:"oil",status:false},{name:"restaurant",status:false},{name:"cosmetic",status:false},
                  {name:"flower",status:false}];
  typeFilterSelectedArray = [];
  producerFilterArray = [];

  filter:any = {};

  @ViewChildren(ProductsListRowComponent,{read: ElementRef}) lists: QueryList<ElementRef>;
  listELements = [];

  constructor(private dataService:DataService, private navCtrl:NavController, private alertCtrl:AlertController, 
    private mathService:MathService, private modalCtrl:ModalController, private productService:ProductService) {

  }

  ngOnInit(){

  }

  ngAfterViewInit() {
    // console.log('ngAfterViewInit', this.lists);
    // this.lists.changes.subscribe(_ => {
      this.listELements = this.lists.toArray();
      // console.log(this.listELements);
    // })
  }

  publish(item:ProductModel){
    this.changeProductStatus(item,'published');
  }

  unpublish(item:ProductModel){
    this.changeProductStatus(item,'unpublished');
  }

  async changeProductStatus(product:ProductModel,status){
    product.status = status;
    this.dataService.updateProductStatus(product);
  } 

  async presentProduct(product:ProductModel,producer:ProfileModel){
    const modal = await this.modalCtrl.create({
      component: ProductViewComponent,
      cssClass: 'shopping-cart',
      componentProps:{
        item:product,
        producer:producer
      }
    });
    return await modal.present();
  }
  async presentProducer(producer:ProfileModel){
    const modal = await this.modalCtrl.create({
      component: ProducerViewComponent,
      cssClass: 'shopping-cart',
      componentProps:{
        producer:producer
      }
    });
    return await modal.present();
  }

  onProducerClickedInFilter(producer:ProfileModel){
    const index = this.producers.findIndex(element => element.key == producer.key);
    const child = this.listELements[index].nativeElement;
    console.log(this.listELements[index],child);
    this.scrollTo.emit(child.offsetTop);
  }

  changeProducerRole(market:MarketModel, item:ProfileModel,role){
    item.role = role;
    this.dataService.updateMarketProducerRole(market,item,role)
  }

  clickProducer(item:ProfileModel){
    this.presentProducer(item)
  }

  clickProduct(item:ProductModel,zone:string){
    if(this.mode == 'order' || this.mode =='owner'){
      console.log(item);
      this.presentProduct(item,item.tournee.producer)
    }
    else if (this.mode =='sale'){
      if(item.status == 'included'){this.removeToSale(item);}
      else { this.addToSale(item)};
    }
    else if(this.mode == 'catalog'){
      this.addToCatalog(item)
    }
    else if(this.mode =='edit'){
      if(zone==='header'){
        if(item.status == 'published'){this.unpublish(item);}
        else { this.publish(item)};        
      }
      else{
        //this.edit(item);
      }
    }
  }

  addToCatalog(item:ProductModel){

  }

  addToSale(item:ProductModel){
    item.status = 'included';
  }
  removeToSale(item:ProductModel){
    item.status = 'notIncluded';
  }

  onQuantityChanged(item:ProductModel){
    this.quantityChanged.emit(item);
  }

  getPhotoURL(tournee:TourneeModel): string {
    if (!!tournee.producer && !!tournee.producer.details && !!tournee.producer.details.shortDetails.photoURL) {
      return tournee.producer.details.shortDetails.photoURL;
    } else if (!!tournee.owner && !!tournee.owner.details && !!tournee.owner.details.shortDetails.photoURL) {
      return tournee.owner.details.shortDetails.photoURL;
    } else if (!!tournee.details.photoURL) {
      return tournee.details.photoURL;
    } else {
      return "assets/photos/" + tournee.details.type + "-small.jpg";
    }
  }

  onFilter(filter:any){
    // necessary to force the refresh of the variable typeFilterSelectedArray
    // const filters = Array.from(this.typeFilterSelectedArray);
    // if(filter.status){
    //   if(!this.typeFilterSelectedArray.includes(filter.name)){
    //     filters.push(filter.name);
    //     this.typeFilterSelectedArray = filters;
    //   }
    // }
    // else{
    //   this.typeFilterSelectedArray = this.typeFilterSelectedArray.filter(function(ele){ 
    //         return ele != filter.name; 
    //     });
    // }
    this.typeFilterSelectedArray = filter;
  }

  onFilterAndSearched(filter:any){
    this.filter = filter
    // this.tourneesFiltered = this.filterProductsAndTournees(this._tournees, filter);
  }

  filterProductsAndTournees(tournees:TourneeModel[],filter:any){
    console.log(tournees);
    const tourneesTransformed = tournees
    .map(tournee =><TourneeModel>{
      ...tournee,
      products:{
        referencesArray: (tournee.products && tournee.products.references)?Object.entries(tournee.products.references)
          .map(item => <ProductModel>{key:item[0], ...item[1] as {}, tournee:tournee} )
          .sort(this.productService.sortProduct()):[]
      },
    });
    console.log(tourneesTransformed);
    const tourneesFiltered = tourneesTransformed.filter(tournee=> tournee.products.referencesArray.length>0);  
    console.log(tourneesFiltered);
    return tourneesFiltered;
  }

  buildFilter(productTypes:any){
    this.typeFilterArray = (Object.entries(productTypes) as any[]).map(item=><any>{
      name:item[0], nameTranslated:item[1].nameTranslated ,status:false, quantity:item[1].array.length
    }).sort((a,b)=>{
      if (a.nameTranslated < b.nameTranslated) {
        return -1;
      }
      if (a.nameTranslated > b.nameTranslated) {
        return 1;
      }
      return 0;
    })
  }

  editManagedProducerTournee(tournee:TourneeModel){
    this.editTournee.emit(tournee);
  }
}
